<div class="full-height notranslate" >
  <gast-cloze-test-ger-info [clozeTestStyleModel]="clozeTestStyleModel" [cTestLogo]="cTestLogo"
    [cTestButtonColor]="cTestButtonColor" [mobileMode]="mobileMode"></gast-cloze-test-ger-info>
</div>